/**
 * useSignOut
 */

import { useDispatch } from 'react-redux';
import { userSignOut } from './actions';

function useSignOut() {
  const dispatch = useDispatch();
  return () => dispatch(userSignOut());
}

export default useSignOut;
